/**
 * Parses a response body as JSON, treating a truly empty body as null instead of throwing. Needed
 * because TypedRoute (from the internal typed-next-api package) sends data nullish-coalesced with
 * message as the body, so a handler that legitimately returns null data ends up with an empty
 * response body instead of the text null, which a plain JSON parse call would otherwise reject.
 *
 * @param res The fetch response to parse.
 * @returns The parsed JSON value, or null if the body was empty.
 */
export const parseNullableJson = async <T>(res: Response): Promise<T | null> => {
    const text = await res.text();

    return text ? JSON.parse(text) as T : null;
};